module.exports = __webpack_public_path__ + "static/concertata-white-3236a06266e8bd57611c0068231fd28f.png";